import { Checkbox, Dropdown, InputNumber, Radio, Slider } from 'antd'
import { useEffect, useMemo, useRef, useState } from 'react'
import {
  CategoriesCheckBoxes,
  SharingStatusCheckBoxes,
  SortByCheckBoxes,
  spaceTypeCheckBoxes,
  TimeStatusCheckBoxes,
} from './filterArrays'
import map from '../../../assets/Images/MapPin.svg'
import { ArrowUp } from '@phosphor-icons/react'
import Down from '../../../helper/Icons/DownIcon'
// import { useSyncParamsWithRoute } from 'hooks/useUpdateSearchParams'
import { useSyncParamsWithRoute } from './useUpdateParams'
import { useGetEventCategories } from 'api/Listings/EventCategories'
import CustomAvatar from 'components/global/CustomAvatar'
import { EventCategoryListing } from 'types/listing/listings'
import ButtonSpinner from 'components/global/ButtonSpinner'

const EventFilters = ({ setParms, parms }: any) => {
  const [checkedItems, setCheckedItems] = useState([])
  const [open, setOpen] = useState(0)
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const { updateRouteParams } = useSyncParamsWithRoute(parms, setParms)

  const handleDocumentClick = (e: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(0)
    }
  }
  const handleDropdownClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick)
    return () => {
      document.removeEventListener('click', handleDocumentClick)
    }
  }, [])

  const [inputValue, setInputValue] = useState(5)
  const [location, setLocation] = useState<{
    latitude: number | null
    longitude: number | null
  }>({
    latitude: null,
    longitude: null,
  })
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('desc')
  const [sharingStauts, setSharingStauts] = useState<string[]>([])
  const [timeStatus, setTimeStatus] = useState<string[]>([])
  const [eventType, setEventType] = useState<string[]>([])

  const {
    isLoading: categoryLoading,
    isFetching: categoryFetching,
    refetch: refetchCategory,
    data: categoriesData,
  } = useGetEventCategories()

  const catIdsFilter = categoriesData?.map((cat: EventCategoryListing) => {
    return {
      label: (
        <div className="flex align-center gap-10">
          <CustomAvatar src={cat.icon.thumb} size={32} name={cat.name} />
          <h5 className="b2 font14">{cat.name}</h5>
        </div>
      ),
      value: cat._id,
    }
  })

  const getLocation = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })
        },
        function (error) {
          console.error('Error getting location:', error.message)
        },
      )
    } else {
      console.log('Geolocation is not available on this device.')
    }
  }

  const onChange = (newValue: any) => {
    setInputValue(newValue)
  }
  const clear = (item: string, setFn?: any) => {
    if (item in parms) {
      const { [item]: _, ...updatedParms } = parms
      setParms({ ...updatedParms, page: 1 })
      updateRouteParams({ [item]: null, page: 1, date: parms?.date })
    }
    setFn && setFn('')
  }
  const TimeStatus = [
    {
      key: 'checkboxes',
      label: (
        <Checkbox.Group
          options={TimeStatusCheckBoxes}
          className="dropdwn checkbox"
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
          value={timeStatus}
          onChange={(val: any) => setTimeStatus(val)}
        />
      ),
    },

    {
      key: 'btns',
      label: (
        <div className="flex justify-between mx-15px">
          <button
            className="clr-btn"
            onClick={() => {
              clear('timeStatus', setTimeStatus)
            }}
          >
            Clear
          </button>
          <button
            onClick={() => {
              setOpen(0)

              if (timeStatus.length > 0) {
                setParms((prevParms: any) => ({
                  ...prevParms,
                   timeStatus: timeStatus,
                  page: 1,
                }))
                updateRouteParams({ timeStatus, page: 1, date: parms?.date })
              }
            }}
            className="aply-btn"
          >
            Apply
          </button>
        </div>
      ),
    },
  ]
  const SharingStatus = [
    {
      key: 'checkboxes',
      label: (
        <Checkbox.Group
          options={SharingStatusCheckBoxes}
          className="dropdwn checkbox"
          value={sharingStauts}
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
          onChange={(val: any) => setSharingStauts(val)}
        />
      ),
    },

    {
      key: 'btns',
      label: (
        <div className="flex justify-between mx-15px">
          <button
            className="clr-btn"
            onClick={() => {
              clear('status', setSharingStauts)
            }}
          >
            Clear
          </button>
          <button
            onClick={() => {
              setOpen(0)
              if (sharingStauts) {
                setParms((prevParms: any) => ({
                  ...prevParms,
                  status: sharingStauts,
                  page: 1,
                }))
                updateRouteParams({
                  status: sharingStauts,
                  page: 1,
                  date: parms?.date,
                })
              }
            }}
            className="aply-btn"
          >
            Apply
          </button>
        </div>
      ),
    },
  ]

  const categoryFilters = [
    {
      key: 'categories',
      label: (
        <div className={'categories_filter list-checkbox'}>
          {categoryLoading || categoryFetching ? (
            <div className="flex align-center justify-center">
              <ButtonSpinner color="#2ba7ca" size={42} />
            </div>
          ) : (
            <Checkbox.Group
              options={catIdsFilter}
              className="dropdwn checkbox"
              style={{
                display: 'flex',
                flexDirection: 'column',
                background: 'transparent',
              }}
              onChange={(val: any) => setCheckedItems(val)}
              value={checkedItems}
            />
          )}
        </div>
      ),
    },
    {
      key: 'btns',
      label: (
        <div className="flex justify-between mx-15px">
          <button
            className="clr-btn"
            onClick={() => {
              clear('categoryIds')
              setOpen(0)
              setCheckedItems([])
            }}
          >
            Clear
          </button>
          <button
            onClick={() => {
              setOpen(0)
              const data = checkedItems[0] && checkedItems

              if (data) {
                setParms((prevParms: any) => ({
                  ...prevParms,
                  categoryIds: data,
                  page: 1,
                }))
                updateRouteParams({
                  categoryIds: data,
                  page: 1,
                  date: parms?.date,
                })
              }
            }}
            className="aply-btn"
          >
            Apply
          </button>
        </div>
      ),
    },
  ]

  // const Categories = [
  //   {
  //     key: 'checkboxes',
  //     label: (
  //       <Checkbox.Group
  //         options={CategoriesCheckBoxes}
  //         className="dropdwn checkbox"
  //         style={{
  //           display: 'flex',
  //           flexDirection: 'column',
  //         }}
  //         onChange={(val: any) => setCheckedItems(val)}
  //         value={checkedItems}
  //       />
  //     ),
  //   },

  //   {
  //     key: 'btns',
  //     label: (
  //       <div className="flex justify-between mx-15px">
  //         <button
  //           className="clr-btn"
  //           onClick={() => {
  //             clear('categoryIds')
  //             setOpen(0)
  //             setCheckedItems([])
  //           }}
  //         >
  //           Clear
  //         </button>
  //         <button
  //           onClick={() => {
  //             setOpen(0)
  //             const data = checkedItems[0] && checkedItems

  //             if (data) {
  //               setParms((prevParms: any) => ({
  //                 ...prevParms,
  //                 categoryIds: data,
  //                 page: 1,
  //               }))
  //               updateRouteParams({
  //                 categoryIds: data,
  //                 page: 1,
  //                 date: parms?.date,
  //               })
  //             }
  //           }}
  //           className="aply-btn"
  //         >
  //           Apply
  //         </button>
  //       </div>
  //     ),
  //   },
  // ]

  const spaceType = [
    {
      key: 'checkboxes',
      label: (
        <Checkbox.Group
          options={spaceTypeCheckBoxes}
          className="dropdwn checkbox"
          value={eventType}
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
          onChange={(val: any) => setEventType(val)}
        />
      ),
    },

    {
      key: 'btns',
      label: (
        <div className="flex justify-between mx-15px">
          <button
            className="clr-btn"
            onClick={() => {
              clear('eventType')
              setOpen(0)
            }}
          >
            Clear
          </button>
          <button
            onClick={() => {
              setOpen(0)
              if (eventType.length > 0) {
                setParms((prevParms: any) => ({
                  ...prevParms,
                  eventType: eventType,
                  page: 1,
                }))
                updateRouteParams({ eventType, page: 1, date: parms?.date })
              } else {
                setParms((prevParms: any) => ({
                  ...prevParms,
                  eventType: undefined,
                  page: 1,
                }))
                updateRouteParams({
                  eventType: undefined,
                  page: 1,
                  date: parms?.date,
                })
              }
            }}
            className="aply-btn"
          >
            Apply
          </button>
        </div>
      ),
    },
  ]

  const Distance = [
    {
      key: 'zipcode',
      label: (
        <div className="mx-15px mt-10px">
          <div className="flex justify-between align-center ">
            <h4 className="w-600 text-14">Zip code</h4>
            <input type="number" className="sm-inp" />
          </div>
          <div className="flex mt-20px mb-10px">
            <img src={map} alt="location" />
            <h4 className="loc ml-10px" onClick={getLocation}>
              {location.latitude && location.longitude
                ? location.latitude.toFixed(2) +
                ' ' +
                location.longitude.toFixed(2)
                : 'My current location'}
            </h4>
          </div>
        </div>
      ),
    },
    {
      key: 'distance',
      label: (
        <div className="mx-15px mt-10px">
          <div className="flex justify-between align-center ">
            <h4 className="w-600 text-14">How many miles</h4>
            <InputNumber
              min={1}
              max={28}
              value={inputValue}
              onChange={onChange}
              className="inp-n"
            />
          </div>
          <div className="mt-20px">
            <Slider
              min={5}
              max={100}
              onChange={onChange}
              value={typeof inputValue === 'number' ? inputValue : 0}
            />
          </div>
        </div>
      ),
    },
    {
      key: 'btns',
      label: (
        <div className="flex justify-between mx-15px">
          <button
            className="clr-btn"
            onClick={() => {
              // Clear local route params and URL for distance and coordinates
              setParms((prevParms: any) => ({
                ...prevParms,
                distance: undefined,
                lat: undefined,
                lng: undefined,
                page: 1,
              }))
              updateRouteParams({
                distance: null,
                lat: null,
                lng: null,
                page: 1,
                date: parms?.date,
              })
              setOpen(0)
              // Reset local location UI state
              setLocation({ latitude: null, longitude: null })
            }}
          >
            Clear
          </button>
          <button
            onClick={() => {
              setOpen(0)
              if (location.latitude === null) {
                setParms((prevParms: any) => ({
                  ...prevParms,
                  distance: inputValue,
                  page: 1,
                }))
                updateRouteParams({
                  distance: inputValue,
                  page: 1,
                  date: parms?.date,
                })
              } else {
                setParms((prevParms: any) => ({
                  ...prevParms,
                  distance: inputValue,
                  lat: location.latitude,
                  lng: location.longitude,
                  page: 1,
                }))
                updateRouteParams({
                  distance: inputValue,
                  lat: location.latitude,
                  lng: location.longitude,
                  page: 1,
                  date: parms?.date,
                })
              }
            }}
            className="aply-btn"
          >
            Apply
          </button>
        </div>
      ),
    },
  ]
  const SortBy = [
    {
      key: 'sort',
      label: (
        <div>
          <Radio.Group
            options={SortByCheckBoxes}
            className="dropdwn checkbox"
            value={sortBy}
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
            onChange={(val: any) => setSortBy(val.target.value)}
          />
          <div className=" border-top pb-10px">
            <div className="dropdwn">
              <h2 className="text-14 w-600 ">Sort Results</h2>
              <Radio.Group
                onChange={(val: any) => setOrderBy(val.target.value)}
                className="flex flex-col mt-10px"
                value={orderBy}
              >
                <Radio value={'asc'}>Ascending</Radio>
                <Radio value={'desc'}>Descending</Radio>
              </Radio.Group>
            </div>
          </div>
        </div>
      ),
    },
    {
      key: 'btns',
      label: (
        <div className="flex justify-between mx-15px">
          <button
            className="clr-btn"
            onClick={() => {
              clear('orderBy', setSortBy)
            }}
          >
            Clear
          </button>
          <button
            onClick={() => {
              setOpen(0)
              if (sortBy && orderBy) {
                setParms((prevParms: any) => ({
                  ...prevParms,
                  sortBy: sortBy,
                  orderBy: orderBy,
                  page: 1,
                }))
                updateRouteParams({
                  sortBy,
                  orderBy,
                  page: 1,
                  date: parms?.date,
                })
              } else if (orderBy) {
                setParms((prevParms: any) => ({
                  ...prevParms,
                  orderBy: orderBy,
                  page: 1,
                }))
                updateRouteParams({ orderBy, page: 1, date: parms?.date })
              } else if (sortBy) {
                setParms((prevParms: any) => ({
                  ...prevParms,
                  sortBy: sortBy,
                  page: 1,
                }))
                updateRouteParams({ sortBy, page: 1, date: parms?.date })
              }
            }}
            className="aply-btn"
          >
            Apply
          </button>
        </div>
      ),
    },
  ]

  useMemo(() => {
    refetchCategory()
  }, [refetchCategory])

  return (
    <div className="flex justify-between align-center  flex-wrap">
      <div
        className="flex align-center flex-wrap mt-25px"
        ref={dropdownRef}
        onClick={handleDropdownClick}
      >
        <h2 className="w-500 text-14">Filter by:</h2>
        <Dropdown
          menu={{
            items: TimeStatus,
          }}
          placement="bottomLeft"
          arrow={false}
          className="ml-20px mr-10px"
          open={open === 1}
          overlayStyle={{ width: '300px' }}
        >
          <button
            className={` ${
              open === 1 ? 'filter-btn-click ' : 'filter-btn'
              } w-500`}
            onClick={() => setOpen(1)}
          >
            Time Status <Down />
          </button>
        </Dropdown>
        <Dropdown
          menu={{
            items: SharingStatus,
          }}
          placement="bottomLeft"
          arrow={false}
          className="mr-10px "
          open={open === 2}
          overlayStyle={{ width: '300px' }}
        >
          <button
            className={` ${
              open === 2 ? 'filter-btn-click ' : 'filter-btn'
              } w-500`}
            onClick={() => setOpen(2)}
          >
            Sharing Status <Down />
          </button>
        </Dropdown>
        <Dropdown
          menu={{
            items: categoryFilters,
          }}
          placement="bottomLeft"
          arrow={false}
          className="mr-10px"
          open={open === 3}
          overlayStyle={{
            width: '300px',
            overflowY: 'auto',
            maxHeight: '400px',
            boxShadow: '1px 1px 21px 10px rgba(99, 103, 103, 0.14)',
          }}
        >
          <button
            className={` ${
              open === 3 ? 'filter-btn-click ' : 'filter-btn'
              } w-500`}
            onClick={() => setOpen(3)}
          >
            Category
            <Down />
          </button>
        </Dropdown>

        <Dropdown
          menu={{
            items: Distance,
          }}
          placement="bottomLeft"
          arrow={false}
          className="mr-10px "
          open={open === 4}
          overlayStyle={{ width: '300px' }}
        >
          <button
            className={` ${
              open === 4 ? 'filter-btn-click ' : 'filter-btn'
              } w-500`}
            onClick={() => setOpen(4)}
          >
            Distance
            <Down />
          </button>
        </Dropdown>

        <Dropdown
          menu={{
            items: spaceType,
          }}
          placement="bottomLeft"
          arrow={false}
          className="mr-10px "
          open={open === 6}
          overlayStyle={{ width: '300px' }}
        >
          <button
            className={` ${
              open === 6 ? 'filter-btn-click ' : 'filter-btn'
              } w-500`}
            onClick={() => setOpen(6)}
          >
            Space type
            <Down />
          </button>
        </Dropdown>
      </div>
      <div
        className="flex align-center mt-25px"
        ref={dropdownRef}
        onClick={handleDropdownClick}
      >
        <h2 className="w-500 text-14">Sort by:</h2>
        <Dropdown
          menu={{
            items: SortBy,
          }}
          placement="bottomRight"
          arrow={false}
          className="ml-20px mr-10px"
          open={open === 5}
          overlayStyle={{ width: '300px' }}
        >
          <button
            className={` ${
              open === 5 ? 'filter-btn-click ' : 'filter-btn'
              } w-500 align-center`}
            onClick={() => setOpen(5)}
          >
            <ArrowUp
              size={18}
              color={'#9ea1a3'}
              style={{
                position: 'relative',
                top: '4px',
              }}
            />{' '}
            Creation Date
            <Down />
          </button>
        </Dropdown>
      </div>
    </div>
  )
}
export default EventFilters
